SectionProfile.Affiliate = Class(
	/**
	 * @lends {SectionProfile.Affiliate#}
	 */
	{
		__NAME: 'SectionProfile.Affiliate',

		bodyClass: 'small-nav grey hide-tablet-footer full-container affiliate-page',
		name: 'affiliate',

		_draw() {
			new RPC('/api/web_rpc.php').send('getAffiliateData', {}, this._onData);
		},

		_onData(data) {
			this._isCopying = false;
			this._data = data;
			this._drawAffiliate();
			this._ready();
		},

		_drawAffiliate() {
			this._linkBox = mkE({
				tag: 'div',
				className: 'affiliate-link-box',
				els: [
					{
						tag: 'h3',
						className: 'color-purple',
						text: this._data.shortLink
					},
					{
						tag: 'div',
						className: 'info-text',
						text: D.Lang.get('affiliate.2021.click-to-copy')
					}
				]
			});
			this._affiliateNode = mkE({
				tag: 'div',
				id: 'affiliate-2021',
				els: [
					{
						tag: 'div',
						className: 'affiliate-header',
						els: [
							{
								tag: 'img',
								src: '/assets/images/affiliate/affiliate-image.png',
								srcset: '/assets/images/affiliate/affiliate-image.png 1x, /assets/images/affiliate/affiliate-image@2x.png 2x, /assets/images/affiliate/affiliate-image@3x.png 3x'
							},
							{
								tag: 'h2',
								text: D.Lang.get('affiliate.2021.title1')
							}
						]
					},
					{
						tag: 'p',
						text: D.Lang.get('affiliate.2021.text1')
					},
					{
						tag: 'p',
						text: D.Lang.get('affiliate.2021.text2')
					},
					this._linkBox,
					{
						tag: 'div',
						className: 'button-container',
						els: [
							{
								tag: 'button',
								className: 'button button-pink',
								text: D.Lang.get('affiliate.2021.invite-friend'),
								onclick: this._inviteFriend
							}
						]
					},
					{
						tag: 'h2',
						text: D.Lang.get('affiliate.2021.title2')
					},
					{
						tag: 'p',
						text: D.Lang.get('affiliate.2021.text3')
					},
					{
						tag: 'div',
						className: 'affiliate-discount-box',
						els: [
							{
								tag: 'h2',
								text: this._data.data.amount + '%'
							},
							{
								tag: 'div',
								className: 'info-text',
								els: [
									{
										tag: 'div',
										text: D.Lang.get('affiliate.2021.users-purchased') + ': ' + this._data.data.purchased
									},
									{
										tag: 'div',
										text: D.Lang.get('affiliate.2021.users-total') + ': ' + (this._data.data.purchased + this._data.data.pending)
									}
								]
							}
						]
					}
				]
			}).append(this._content);

			if (this._data.data.amount) {
				mkE({
					tag: 'div',
					className: 'button-container',
					els: [
						{
							tag: 'a',
							className: 'button ' + (D.APP_WEBVIEW ? 'button-dark-grey' : 'button-turquoise'),
							text: D.Lang.get('affiliate.2021.use-discount'),
							href: D.url('/events'),
							onclick: this._onUseDiscount
						}
					]
				}).append(this._affiliateNode);
			}

			mkE({
				tag: 'div',
				className: 'affiliate-disclaimer',
				text: D.Lang.get('affiliate.2021.disclaimer')
			}).append(this._affiliateNode);

			if (D.APP_WEBVIEW) {
				this._linkBox.onclick = this._appCopy
			} else {
				this._initClipboard();
			}
		},

		_initClipboard() {
			this._clipboardJS = new ClipboardJS(this._linkBox, {
				text: this._getCopyText
			});
			this._clipboardJS.on('success', this._copied);
		},

		_getCopyText() {
			return this._data.link;
		},

		_copied() {
			this._isCopying = true;
			if (!D.APP_WEBVIEW && this._clipboardJS) {
				this._clipboardJS.destroy();
				setTimeout(this._initClipboard, 2000);
			}
			if (this._copyNode && this._copyNode.parentNode) {
				this._copyNode.remove();
			}
			this._copyNode = mkE({
				tag: 'div',
				className: 'copied',
				els: [
					{
						tag: 'h3',
						text: D.Lang.get('affiliate.2021.copied')
					}
				]
			}).append(this._linkBox);
			setTimeout(this._removeCopied, 2250);
		},

		_removeCopied() {
			this._copyNode.remove();
			this._isCopying = false;
		},

		_sendPostMessage(data) {
			if (window.Android) {
				window.Android.postMessage(JSON.stringify(data));
			} else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
				window.webkit.messageHandlers.iosListener.postMessage(data);
			} else {
				window.postMessage(JSON.stringify(data));
			}
		},

		_appCopy() {
			if (this._isCopying) {
				return;
			}
			this._sendPostMessage({
				action: 'copy',
				data: {
					link: this._data.link
				}
			});
			this._copied();
		},

		_inviteFriend() {
			if (D.APP_WEBVIEW) {
				this._appInviteFriend();
				return;
			}
			let shareData = {
				url: this._data.link,
				text: D.Lang.get('affiliate.2021.share-text').replace('$LINK$', this._data.link).replace('$NAME$', D.me.name)
			}
			if (navigator.canShare && navigator.canShare(shareData)) {
				navigator.share(shareData);
				return;
			}
			let shareWindow = new SectionProfile.Affiliate.SharePopup(this._data.link, this._data.shortLink);
			this._modal = new T.Popup({
				className: 'popup-share'
			});
			this._modal.setContent(shareWindow.node);
			this._modal.open();
			shareWindow.onShow();
		},

		_appInviteFriend() {
			this._sendPostMessage({
				action: 'share',
				data: {
					link: this._data.link,
					text: D.Lang.get('affiliate.2021.share-text').replace('$LINK$', this._data.link).replace('$NAME$', D.me.name)
				}
			});
		},

		_onUseDiscount(e) {
			if (!D.APP_WEBVIEW) {
				return;
			}
			e.preventDefault();
			e.stopPropagation();
			this._appUseDiscount();
			return false;
		},

		_appUseDiscount() {
			this._sendPostMessage({
				action: 'use-discount'
			});
		}
	},
	SectionProfileBase
);

SectionProfile.Affiliate.SharePopup = Class(
	/**
	 * @lends {SectionProfile.Affiliate.SharePopup#}
	 */
	{
		__NAME: 'SectionProfile.Affiliate',

		__construct(link, shortLink) {
			this._link = link;
			this._shortLink = shortLink;

			this.node = mkE({
				tag: 'div',
				className: 'affiliate-share-popup',
				els: [
					{
						tag: 'h2',
						text: D.Lang.get('affiliate.2021.share.popup-title')
					},
					{
						tag: 'div',
						className: 'share-options',
						els: [
							{
								tag: 'a',
								href: ' https://wa.me/?text=' + encodeURIComponent(this._getText()),
								target: '_blank',
								className: 'share-option',
								els: [
									{
										tag: 'div',
										className: 'share-icon share-icon-whatsapp'
									},
									'Whatsapp'
								]
							},
							{
								tag: 'a',
								href: ' mailto://?body=' + encodeURIComponent(this._getText()),
								target: '_blank',
								className: 'share-option',
								els: [
									{
										tag: 'div',
										className: 'share-icon share-icon-email'
									},
									D.Lang.get('affiliate.2021.share.email')
								]
							}
						]
					},
					this._linkBox = mkE({
						tag: 'div',
						className: 'affiliate-link-box',
						els: [
							{
								tag: 'h3',
								className: 'color-purple',
								text: this._shortLink
							},
							{
								tag: 'div',
								className: 'info-text',
								text: D.Lang.get('affiliate.2021.click-to-copy')
							}
						]
					})
				]
			});
		},

		onShow() {
			this._initClipboard();
		},

		_initClipboard() {
			this._clipboardJS = new ClipboardJS(this._linkBox, {
				text: this._getCopyText
			});
			this._clipboardJS.on('success', this._copied);
		},

		_getCopyText() {
			return this._link;
		},

		_copied() {
			this._isCopying = true;
			this._clipboardJS.destroy();
			setTimeout(this._initClipboard, 2000);
			if (this._copyNode && this._copyNode.parentNode) {
				this._copyNode.remove();
			}
			this._copyNode = mkE({
				tag: 'div',
				className: 'copied',
				els: [
					{
						tag: 'h3',
						text: D.Lang.get('affiliate.2021.copied')
					}
				]
			}).append(this._linkBox);
			setTimeout(this._removeCopied, 2250);
		},

		_removeCopied() {
			this._copyNode.remove();
			this._isCopying = false;
		},

		_getText() {
			return D.Lang.get('affiliate.2021.share-text').replace('$LINK$', this._link);
		}
	},
	mkE.Base
)